







































import { Component, Prop, Vue } from 'vue-property-decorator';
import Indicators, { Rating, Type } from '@solucx/indicators';
import ClassItemRate from '@/models/interfaces/ClassItemRate';

@Component({ components: {} })
export default class SurveyCard extends Vue {
  @Prop({ default: (): ClassItemRate[] => [] }) public classes: ClassItemRate[];
  @Prop({ default: Type.NPS }) public journeyType: Type;
  @Prop() public value: number;
  @Prop() public npsColor: boolean;
  @Prop() public forceBreak: boolean;
  @Prop() public whiteMode: boolean;
  @Prop() public allowHtml: boolean;
  @Prop() public showSendButton: boolean;

  public NEGATIVE: Rating = Rating.NEGATIVE;
  public NEUTRAL: Rating = Rating.NEUTRAL;
  public POSITIVE: Rating = Rating.POSITIVE;

  get rating(): Rating {
    const indicator = Indicators.getIndicator(this.journeyType);
    return indicator.getRating(this.value);
  }

  get hasManyClasses(): boolean {
    if (this.classes.length > 6) {
      return true;
    }
    return false;
  }

  public get hideSecondaryTemplate(): boolean {
    const notHaveClasses: boolean = this.classes.length === 0;
    const notShowSubmitButton: boolean = !this.showSendButton;

    if (notHaveClasses && notShowSubmitButton) return true;
    return false;
  }

  public get isJourneyTypeNone(): boolean {
    return this.journeyType === 20;
  }
}
